// src/components/Layout/PortraitLayout.jsx
import React from 'react';
import Whiteboard from '../RecordPlayer/Whiteboard';
import VideoPlayer from '../RecordPlayer/VideoPlayer';
import DiscussionPanel from '../RecordPlayer/DiscussionPanel';

const PortraitLayout = ({ 
  roomid, 
  currentTime, 
  isPlaying,
  playbackRate,
  sessionInfo,
  teacherInfo,
  presentationInfo,
  whiteboardInfo,
  cursorInfo,
  chatInfo,
  videoInfo,
  isMediaReady,
  onVideoStateChange
}) => {
  return (
    <div className="portrait-layout">
      <div className="teacher-container">
        <VideoPlayer 
          videoInfo={videoInfo}
          teacherInfo={teacherInfo}
          currentTime={currentTime} 
          isPlaying={isPlaying} 
          playbackRate={playbackRate}
          isMediaReady={isMediaReady}
          onVideoStateChange={onVideoStateChange}
        />
      </div>
      
      <div className="whiteboard-section">
        <Whiteboard roomid={roomid} currentTime={currentTime} whiteboardInfo={whiteboardInfo} presentationInfo={presentationInfo} cursorInfo={cursorInfo}/>
      </div>
      
      <div className="discussion-section">
        <DiscussionPanel roomid={roomid} currentTime={currentTime} chatInfo={chatInfo} />
      </div>
    </div>
  );
};

export default PortraitLayout;